// import md5 from 'js-md5'
import store from '@/store'

var guid = '-1'
var signatures = '1'
var code = 'Admin-Code'
var role = '1'
var device = 'web-pc-student'

const autograph = function auths(url, query) {
  const version = 1.0 // 当前版本
  const timestamp = Date.parse(new Date()) // 获取客户端当前时间
  const time = timestamp / 1000 // 转换客户端时间
  const param = JSON.stringify(query) // 提交参数
  const token = store.state.user.token|| '' // 获取用户token
  if (token) {
    var headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    // 获取用户guid
    guid = store.state.user.guid
    code = store.state.user.code
    // role = store.getters.selectedRole && store.getters.selectedRole.role
    // 定义加密hash表
    var hashs = [
      [11, 4, 1, 17, 22, 29],
      [2, 12, 19, 23, 30, 31],
      [4, 12, 8, 1, 5, 10],
      [6, 16, 31, 15, 12, 18],
      [8, 20, 12, 18, 22, 20],
      [10, 24, 17, 27, 1, 23],
      [12, 28, 13, 19, 20, 21],
      [14, 0, 20, 29, 18, 20]
    ]
    // 初始化加密使用token
    var m = ''
    // 获取token里的值
    var str = token.substr(2, 1) + token.substr(5, 1) + token.substr(8, 1)
    // 转为整形
    var index = parseInt(str, 16) % 8
    // 重新组成加密使用的token
    for (var i in hashs[index]) {
      m += token[hashs[index][i]]
    }
    signatures = null

    // 加密
    // signatures = md5(url + time + guid + param + m + code)
  } else {
    // signatures = md5(url + time + guid + param + 'jcry_common' + code)
  }

  const encryParam = { version, time, param, signatures, guid, code, role, device}
  return { encryParam, headers }
}

export default autograph
